import {Page} from "../Page";
import {$} from "../Application";

export class ImageOutput extends Page {
    runOnCurrentPage(): boolean {
        return $('[data-image-output]').length > 0;
    }

    onReady() {
        const $inputs = $('[data-image-output]');
        $inputs.each((i, input) => {
            const $input = $(input);
            $input.on('input change', e => {
                const output = $input.data('imageOutput');
                $(output).prop('src', $input.val());
            });
        });
        $inputs.trigger('change');
    }
}
